import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BugReportService } from '../../service/bug-report.service';
import { AvatarComponent } from "../avatar/avatar.component";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { VersionComponent } from "../version/version.component";
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, AvatarComponent, MatButtonModule, MatMenuModule, MatIconModule, VersionComponent, MatTooltipModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.less'
})
export class FooterComponent {
  bugReportService = inject(BugReportService);

  openLink(url: string) {
    window.open(url, '_blank');
  }

  submitBugReport() {
    this.bugReportService.sendReport();
  }
}
